import { appConfig } from '../config/appConfig';
import type { AuthResponse } from '../types/domain';
import { apiClient } from './apiClient';

export type QrLoginSession = {
  sessionId: string;
  client: string;
  clientLabel: string;
  clientDescription?: string;
  qrPayload: string;
  qrUrl: string;
  expiresAt: string;
  remainingSeconds: number;
  pollIntervalMs: number;
};

type QrLoginPollPayload =
  | ({ status: 'pending' } & Pick<QrLoginSession, 'expiresAt' | 'remainingSeconds' | 'pollIntervalMs' | 'clientLabel'>)
  | ({ status: 'expired' })
  | ({ status: 'confirmed' } & AuthResponse & { clientLabel?: string });

function buildDevicePayload() {
  return { platform: 'web', deviceType: 'web', source: 'webapp2' };
}

export const qrLoginService = {
  async createSession(): Promise<QrLoginSession> {
    const payload = await apiClient.requestJson<{ success?: boolean; data?: QrLoginSession; message?: string; error?: string }>(
      '/api/auth/qr-login/sessions',
      {
        method: 'POST',
        auth: false,
        body: {
          client: 'webapp2',
          device: buildDevicePayload(),
          refreshTransport: appConfig.refreshTransport,
        },
      },
    );
    if (!payload.success || !payload.data?.sessionId) {
      throw new Error(payload.message || payload.error || '创建扫码登录失败');
    }
    return payload.data;
  },

  async poll(sessionId: string): Promise<QrLoginPollPayload> {
    const payload = await apiClient.requestJson<{ success?: boolean; data?: QrLoginPollPayload; message?: string; error?: string }>(
      `/api/auth/qr-login/sessions/${encodeURIComponent(sessionId)}`,
      { auth: false },
    );
    if (!payload.success || !payload.data) {
      throw new Error(payload.message || payload.error || '查询扫码登录状态失败');
    }
    return payload.data;
  },
};
